
/** 
*@author: Sirisha.M
*@Description : This component is mainly for creating failure Report and get list of Failure reports and Failure Analysis
**/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, Input, Tabs, Form, Select, DatePicker, Upload, message, Modal, Tooltip, Drawer, Space, Collapse } from 'antd';
import HierarchyModal from './HierarchyModal';
import { getHierarchyTreeData, getDeviceList, getUserHeirarchyData, submitReport, updateReport, createAssign, createFailure, updateFailure, createCorrectiveActions } from './ChartCalls';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { SearchOutlined, UploadOutlined, UpSquareOutlined, EditOutlined, PlusOutlined, EyeOutlined, DownloadOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import TextArea from 'antd/es/input/TextArea';
// import { translation } from '../../commons/translation';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const FailureReports = (props) => {
  // const [list, setList] = useState([]);
  const [presentActiveKey, setPresentActiveKey] = useState('List');
  const [parentPresentActiveKey, setParentPresentActiveKey] = useState('Reporting');

  const [formObject, setFormObject] = useState({});
  const [analysisFormObject, setAnalysisFormObject] = useState({});
  const [correctiveFormObject, setCorrectiveFormObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [Questions, setQuestions] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);

  const [SeverityList, setSeverityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [userList, setUserList] = useState([]);

  const [questionsData, setQuestionsData] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);
  const [questionVisible, setQuestionVisible] = useState(false);
  const [showusecasedownloadModal, setShowusecasedownloadModal] = useState(false);
  const [analysisShowusecasedownloadModal, setAnalysisShowusecasedownloadModal] = useState(false);

  const [correctiveShowusecasedownloadModal, setCorrectiveShowusecasedownloadModal] = useState(false);

  // const [checked, setChecked] = useState(false);1
  const [selectedKey, setSelectedKey] = useState('');
  const [selectedRolesList, setSelectedRolesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [RoleId, setRoleId] = useState(null);
  const [status, setStatus] = useState(null);
  const [correctiveStatus, setCorrectiveStatus] = useState(null);
  const [correctiveButton, setCorrectiveButton] = useState(false);




  const h1Ref = useRef(null);
  const h2Ref = useRef(null);
  const h3Ref = useRef(null);
  const h4Ref = useRef(null);
  const [form] = Form.useForm();
  const myRef = useRef(null);
  const QuestionRef = useRef(null);

  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let devicesList = await getDeviceList();
      setDevicesList(devicesList);
      let HierarchyData = await getUserHeirarchyData();
      let RoleId = JSON.parse(localStorage.get('roleId'));
      setRoleId(RoleId);
      let permissionsArray =
        HierarchyData &&
        HierarchyData['belongsTo'] &&
        HierarchyData['belongsTo']['sites'] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

      const EquipmentList = await getHierarchyTreeData(
        permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
      );
      let roles =
        HierarchyData &&
        HierarchyData['belongsTo'] &&
        HierarchyData['belongsTo']['sites'] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['role'];

      let selectedRolesList = await getRolesPermissionsList(roles && roles.Id);
      let RolesData =
        selectedRolesList &&
        selectedRolesList.RolesAndPermissions &&
        selectedRolesList.RolesAndPermissions[0] &&
        selectedRolesList.RolesAndPermissions[0].permissions;
      setSelectedRolesList(RolesData);
      let activeKey = '';
      let data = [];

      if (RolesData && RolesData.includes('Reporting')) {
        activeKey = 'Reporting';
        data = await getList('Reporting');
      } else if (RolesData && RolesData.includes('Failure Reporting And Assignment')) {
        activeKey = 'Failure Reporting And Assignment';
        data = await getList('Failure Reporting And Assignment');
      } else {
        activeKey = 'Analysis and Corrective Actions';
        data = await getAnalysisList('Analysis and Corrective Actions');
      }
      // let data = await getList(activeKey);
      setParentPresentActiveKey(activeKey);

      setEquipmentList(EquipmentList);
      setDataSource(data);
      let FailureTypeList = await getFailureList();
      setFailureTypeList(FailureTypeList);
      let SeverityList = await getSeverityList();
      setSeverityList(SeverityList);
      let departmentList = await getDepartmentList();
      setDepartmentList(departmentList);
      let userList = await getUserList();
      setUserList(userList);
    };
    fetchData();
  }, []);
  const getList = async (activeTab) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/reporting/get?SiteId=${siteId}&ScreenName=${activeTab}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getAnalysisList = async (activeTab) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/analysis/getAnalysisList?SiteId=${siteId}&ScreenName=${activeTab}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getFailureList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/failureTypes/get?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getFailureCodeList = async (checkedValue) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/reporting/getParmsByDevice?SiteId=${siteId}&Device=${checkedValue}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getSeverityList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/severity/get?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getById = async (Id, screen) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/reporting/get?Id=${Id}&SiteId=${siteId}&ScreenName=${screen}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getAnalysisById = async (Id, screen) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/analysis/get?ReportId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getCorrectiveById = async (Id) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/correctiveAction/get?ReportId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getDepartmentList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/department/get?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getUsersList = async (Id) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/user/getUsersByDepartmentId?DepartmentId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getUserList = async () => {
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const siteId = localStorage.get('currentSite');
    let data = {
      url: `/api/user/get?SiteId=${siteId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    };
    return axios(data)
      .then((response) => {
        return response.data;
      })

      .catch(() => { });
  };
  const getQuestionsList = async (FailureType, selectedEquip) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'POST',
      url: `/api/fracas/questions/getQuestions?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Device: selectedEquip,
        failureTypeId: FailureType
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getRolesPermissionsList = async (ID) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'POST',
      url: `/api/permission/getById?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { RoleId: [ID] }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getStatusList = async (status) => {
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const siteId = localStorage.get('currentSite');
    let data = {
      url: `/api/fracas/assign/statusDropdown?SiteId=${siteId}&Status=${status}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    };
    return axios(data)
      .then((response) => {
        return response.data;
      })

      .catch(() => { });
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0] || '');
    setSearchedColumn(dataIndex);
  };


  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    setSearchText('');
    confirm();
    setSearchedColumn('');
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm:ss' }}
            format="YYYY-MM-DD HH:mm:ss"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm:ss') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm:ss')] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm:ss') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm:ss')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={searchText ? [searchText] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });


  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue([]);
    }

    setTreeVisible(false);
  };
  const onQuestionModalCancel = () => {
    setQuestionVisible(false);
    if (questionsData && questionsData.length !== 0) {
      QuestionRef.current &&
        QuestionRef.current.setFieldsValue({
          Questions: questionsData
        });
    } else {
      QuestionRef.current &&
        QuestionRef.current.setFieldsValue({
          Questions: []
        });
      setQuestionsData([]);
    }
  };
  const onQuestionModalsOk = () => {
    setQuestionVisible(false);
    let data = QuestionRef.current && QuestionRef.current.getFieldsValue();
    setQuestionsData(data.Questions);
    // QuestionRef.current && QuestionRef.current.setFieldsValue({
    //   Questions: []
    // })
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setSelectedDevice(value);
    setFailureTypeId(null);
    setQuestionsList([]);
    setTreeVisible(false);
    h1Ref.current &&
      h1Ref.current.setFieldsValue({
        Device: value,
        FailureTypeId: null,
        FaultCode: null
      });
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestionsData([]);
  };

  const onCancel = () => {
    ResetFields();
    correctiveResetFields();
    setCorrectiveStatus(null);
    setCorrectiveButton(false);
    setPresentActiveKey('List');
  };
  const onCorrectiveActionClick = () => {
    setCorrectiveStatus('Analysis Completed');
    setCorrectiveButton(false);
  };

  const ResetFields = async () => {
    form.resetFields();
    form.setFieldsValue({
      ReportedDate: dayjs(),
      ReportedBy: props?.userProfile?.user?.FirstName,
      Status: formObject.Id ? null : "Open",
      // ...other defaults
    });

    let formData = {
      Device: null,
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: formObject.Id ? null : "Open",

      // Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestionsData([]);
    setFormObject(formData);
    setSelectedDevice(null);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    setFailureCodeList([]);
    setUsersList([]);
    setStatus(formObject.Id ? null : "Open");
  };
  const reportingResetFields = () => {
    h1Ref.current &&
      h1Ref.current.setFieldsValue({
        Type: null,
        Equipment: null,
        FailureTypeId: null,
        FaultCode: null,
        FailureDescription: null,
        SeverityId: null,
        Impact: null,
        OccuranceDate: null,
        OccuranceCount: null,
        Remarks: null,
        ReportedDate: dayjs(),
        // Attachments: [],
        ReportedBy:
          props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
        Comments: null,
        Status: null,
        UserId: null,
        DepartmentId: null
      });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: moment(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestionsData([]);
    setRoleId(null);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const analysisResetFields = () => {
    h2Ref.current &&
      h2Ref.current.setFieldsValue({
        Type: null,
        Equipment: null,
        FailureTypeId: null,
        FaultCode: null,
        FailureDescription: null,
        SeverityId: null,
        Impact: null,
        OccuranceDate: null,
        OccuranceCount: null,
        Remarks: null,
        ReportedDate: dayjs(),
        // Attachments: [],
        ReportedBy:
          props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
        Comments: null,
        Status: null,
        UserId: null,
        DepartmentId: null
      });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestionsData([]);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const correctiveResetFields = () => {
    h4Ref.current &&
      h4Ref.current.setFieldsValue({
        ChangeRecommendations: null,
        CorrectiveActionType: null,
        CorrectiveActionsAttachments: [],
        ImplementedCorrectiveActions: null,
        PlannedCorrectiveActions: null,
        VerificationAndValidationFieldRemarks: null
      });
    let formData = {
      // ...formObject,
      ChangeRecommendations: null,
      CorrectiveActionType: null,
      CorrectiveActionsAttachments: [],
      ImplementedCorrectiveActions: null,
      PlannedCorrectiveActions: null,
      VerificationAndValidationFieldRemarks: null,

    };
    setCorrectiveFormObject(formData);
    setCorrectiveButton(false);
    setCorrectiveStatus(null);
  };
  const onChangeDepartment = async (value) => {
    let userList = await getUsersList(value);
    setUsersList(userList);
  };
  // const onCheck = (e) => {
  //   setChecked(e.target.checked);
  // };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const analysisHandleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setAnalysisShowusecasedownloadModal(true);
    }
  };
  const correctiveHandleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setCorrectiveShowusecasedownloadModal(true);
    }
  };
  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        filename: file.name
      });
    };
  };
  const fileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject) {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];

          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject &&
            formObject['Attachments'] &&
            formObject['Attachments'].push({ Id: id, file: Name });
        }
      }

      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const correctiveFileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (correctiveFormObject) {
        if (correctiveFormObject['CorrectiveActionsAttachments']) {
          correctiveFormObject['CorrectiveActionsAttachments'] =
            correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] ? correctiveFormObject['CorrectiveActionsAttachments'] : [];

          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        } else {
          correctiveFormObject['CorrectiveActionsAttachments'] = [];
          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] && correctiveFormObject['CorrectiveActionsAttachments'].length !== 0) {
          correctiveFormObject['CorrectiveActionsAttachments'] =
            correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] ? correctiveFormObject['CorrectiveActionsAttachments'] : [];
          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        } else {
          correctiveFormObject &&
            correctiveFormObject['CorrectiveActionsAttachments'] &&
            correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        }
      }

      setCorrectiveFormObject(correctiveFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const analysisFileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (analysisFormObject) {
        if (analysisFormObject['AnalysisAttachments']) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];

          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject['AnalysisAttachments'] = [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (analysisFormObject && analysisFormObject['AnalysisAttachments'] && analysisFormObject['AnalysisAttachments'].length !== 0) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject &&
            analysisFormObject['AnalysisAttachments'] &&
            analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      }

      setAnalysisFormObject(analysisFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const onStatusChange = (value) => {
    setStatus(value);
  };

  const onFinishFailed = () => {
    message.error("Please add mandatory fields");
  };
  const onCorrectiveFinishFailed = () => {
    message.error("Please add mandatory fields in Corrective Actions");
  };
  const onReportFormSubmit = async () => {
    let data = QuestionRef.current && QuestionRef.current.getFieldsValue();
    QuestionRef.current && QuestionRef.current.validateFields();
    let questionsValid = null;
    if (data && data.Questions && Array.isArray(data.Questions)) {
      questionsValid = !data.Questions.some(que => {
        return que === undefined || Object.values(que).length === 1;
      });
    }


    setQuestionsData(data.Questions);
    h1Ref.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          OccuranceDate: dayjs(values.OccuranceDate).format('YYYY-MM-DD HH:mm:ss'),
          ReportedDate: dayjs(values.ReportedDate).format('YYYY-MM-DD HH:mm:ss'),
          Device: selectedDevice,
          Attachments: formObject.Attachments,
          Questions: data.Questions
        };

        if (values.Id && values.Id !== null) {
          let payload = {};
          if (values.Status !== 'Assigned') {
            payload = {
              ...values
            };

            if (questionsValid !== false) {
              let response = await updateReport(payload);
              if (response && response.status && response.status === 200) {
                message.success(response.data && response.data.message);
                ResetFields();
                setPresentActiveKey('List');
                let data = await getList('Failure Reporting And Assignment');
                setDataSource(data);
                // setSelectedDevice(null)
              } else {
                message.warning('Error while Update');
              }
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          } else {
            payload = {
              ReportId: values.Id,
              UserId: values.UserId,
              DepartmentId: values.DepartmentId,
              User_Role: `${values.UserId}_${RoleId}`,
              Status: values.Status
            };
            if (questionsValid !== false) {
              let response = await createAssign(payload);
              if (response && response.status && response.status === 200) {
                message.success(response.data && response.data.message);
                ResetFields();
                setPresentActiveKey('List');
                let data = await getList('Failure Reporting And Assignment');
                setDataSource(data);
                // setSelectedDevice(null)
              } else {
                message.warning('Error while Update');
              }
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          }


        } else {
          if (questionsValid !== false) {
            let response = await submitReport(values);
            if (response && response.status && response.status === 200) {
              message.success(response.data && response.data.message);
              ResetFields();
              setPresentActiveKey('List');
              let data = await getList('Failure Reporting And Assignment');
              setDataSource(data);
              // setSelectedDevice(null)
            } else {
              message.warning('Error while create');
            }
          } else if (questionsValid === false) {
            message.warning("Please add Questions");
          }
        }


      })
      .catch((error) => {
        message.warning(error);
      });
  };
  const onAnalysisFormSubmit = () => {
    let data = h2Ref.current && h2Ref.current.getFieldsValue();

    if (correctiveStatus && correctiveStatus !== null && correctiveStatus === 'Analysis Completed') {
      h4Ref.current
        .validateFields()
        .then(async (values) => {
          values = {
            ...values,
            CorrectiveActionsAttachments: correctiveFormObject.CorrectiveActionsAttachments
          };
          let payload = {
            ...values,
            Status: data.Status,
            ReportId: data.Id
          };
          let response = await createCorrectiveActions(payload);
          if (response && response.status && response.status === 200) {
            message.success(response.data && response.data.message);
            analysisResetFields();
            correctiveResetFields();
            setPresentActiveKey('List');
            let data = await getAnalysisList('Analysis and Corrective Actions');
            setDataSource(data);
            //     // setSelectedDevice(null)
          } else {
            message.warning('Error while create');
          }

        })
        .catch((error) => {
          message.warning(error);
        });

    } else {
      h3Ref.current
        .validateFields()
        .then(async (values) => {
          values = {
            ...values,
            AnalysisStartDate: dayjs(values.AnalysisStartDate).format('YYYY-MM-DD HH:mm:ss'),
            AnalysisDueDate: dayjs(values.AnalysisDueDate).format('YYYY-MM-DD HH:mm:ss'),
            AnalysisAttachments: analysisFormObject.AnalysisAttachments
          };
          let payload = {};

          if ((values.Id && values.Id === null) || values.Id === undefined) {
            payload = {
              ...values,
              ReportId: data.Id,
              Status: data.Status

            };
            let response = await createFailure(payload);
            if (response && response.status && response.status === 200) {
              if (response.data && response.data.Status && response.data.Status === 'Analysis Completed') {
                setCorrectiveButton(true);
                let userList = await getUserList();
                setUserList(userList);
                let StatusList = await getStatusList(data.Status);
                setStatusList(StatusList);
                try {
                  const editedRow = await getAnalysisById(data.Id, 'Analysis and Corrective Actions');

                  if (!editedRow) {
                    console.error('No record found');
                    return;
                  }
                  let FailureCodeList = await getFailureCodeList(editedRow.Device);
                  setFailureCodeList(FailureCodeList);

                  if (editedRow && editedRow.DepartmentId) {
                    let userList = await getUsersList(editedRow && editedRow.DepartmentId);
                    setUsersList(userList);
                  }
                  // const questionsList = await getQuestionsList(editedRow[0].FailureTypeId);
                  // setQuestionsList(questionsList);
                  h2Ref.current &&
                    h2Ref.current.setFieldsValue({
                      Id: editedRow.ReportId,
                      Device: editedRow.Device,
                      FailureTypeId: editedRow.FailureTypeId,
                      FaultCode: editedRow.FaultCode,
                      Impact: editedRow.Impact,
                      OccuranceCount: editedRow.OccuranceCount,
                      Remarks: editedRow.Remarks,
                      SeverityId: editedRow.SeverityId,
                      OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
                      ReportedDate: dayjs(editedRow.ReportedDate),
                      FailureDescription: editedRow.FailureDescription,
                      ReportedBy: editedRow.ReportedName,
                      Comments: editedRow && editedRow.Comments,
                      Status: editedRow && editedRow.Status,
                      DepartmentId: editedRow && editedRow.DepartmentId,
                      UserId: editedRow && editedRow.UserId
                    });
                  if (editedRow && editedRow.Id && editedRow.Id !== null) {
                    h3Ref.current &&
                      h3Ref.current.setFieldsValue({
                        Id: editedRow.Id,
                        AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
                        AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
                        // SentDatetoVendor: dayjs(editedRow.SentDatetoVendor).utc(),
                        // WarrantyExpiryDate: dayjs(editedRow.WarrantyExpiryDate).utc(),
                        ChangeRecommendations: editedRow.ChangeRecommendations,
                        FailureCause: editedRow.FailureCause,
                        ContributingFactors: editedRow.ContributingFactors,
                        AnalysisComments: editedRow.AnalysisComments,
                        AnalysisAttachments: editedRow.AnalysisAttachments
                      });

                    const updatedForm1 = {
                      Id: editedRow.Id,
                      AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
                      AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
                      // SentDatetoVendor: dayjs(editedRow.SentDatetoVendor).utc(),
                      // WarrantyExpiryDate: dayjs(editedRow.WarrantyExpiryDate).utc(),
                      ChangeRecommendations: editedRow.ChangeRecommendations,
                      FailureCause: editedRow.FailureCause,
                      ContributingFactors: editedRow.ContributingFactors,
                      AnalysisComments: editedRow.AnalysisComments,
                      AnalysisAttachments: editedRow.AnalysisAttachments
                    };
                    setAnalysisFormObject(updatedForm1);
                  } else {
                    h3Ref.current &&
                      h3Ref.current.setFieldsValue({
                        AnalysisStartDate: null,
                        AnalysisDueDate: null,
                        // SentDatetoVendor: null,
                        // WarrantyExpiryDate: null,
                        ChangeRecommendations: null,
                        FailureCause: null,
                        ContributingFactors: null,
                        AnalysisComments: null,
                        AnalysisAttachments: []
                      });

                    const updatedForm1 = {
                      Id: null,
                      AnalysisStartDate: null,
                      AnalysisDueDate: null,
                      // SentDatetoVendor: null,
                      // WarrantyExpiryDate: null,
                      ChangeRecommendations: null,
                      FailureCause: null,
                      ContributingFactors: null,
                      AnalysisComments: null,
                      AnalysisAttachments: []
                    };
                    setAnalysisFormObject(updatedForm1);

                  }

                  const updatedForm = {
                    Id: editedRow.ReportId,
                    Device: editedRow.Device,
                    FailureTypeId: editedRow.FailureTypeId,
                    FaultCode: editedRow.FaultCode,
                    Impact: editedRow.Impact,
                    OccuranceCount: editedRow.OccuranceCount,
                    Remarks: editedRow.Remarks,
                    SeverityId: editedRow.SeverityId,
                    OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
                    ReportedDate: dayjs(editedRow.ReportedDate),
                    FailureDescription: editedRow.FailureDescription,
                    ReportedBy: editedRow.ReportedName,
                    Attachments: editedRow.Attachments,
                    Comments: editedRow && editedRow.Comments,
                    Status: editedRow && editedRow.Status,
                    Questions: editedRow && editedRow.Questions,
                    DepartmentId: editedRow && editedRow.DepartmentId,
                    UserId: editedRow && editedRow.UserId
                  };
                  setFailureTypeId(editedRow.FailureTypeId);
                  setFormObject(updatedForm);
                  setSelectedDevice(editedRow.Device);

                  const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
                  setQuestionsList(questionsList);
                  QuestionRef.current &&
                    QuestionRef.current.setFieldsValue({
                      Questions: editedRow.Questions
                    });
                  setQuestions(editedRow.Questions);
                } catch (error) {
                  console.error('Error', error);
                }
              } else {
                message.success(response.data && response.data.message);
                analysisResetFields();
                setPresentActiveKey('List');
                let data = await getAnalysisList('Analysis and Corrective Actions');
                setDataSource(data);
                // setSelectedDevice(null)
              }
            } else {
              setCorrectiveStatus(null);
              message.warning('Error while Create');
            }
          } else {
            payload = {
              ...values,
              ReportId: data.Id,
              Id: values.Id,
              Status: data.Status
            };
            let response = await updateFailure(payload);
            if (response && response.status && response.status === 200) {
              message.success(response.data && response.data.message);
              analysisResetFields();
              setPresentActiveKey('List');
              let data = await getAnalysisList('Analysis and Corrective Actions');
              setDataSource(data);
              //     // setSelectedDevice(null)
            } else {
              message.warning('Error while create');
            }
          }
        })
        .catch((error) => {
          message.warning(error);
        });
    }
  };
  const addNew = (key) => {
    setSelectedKey(key);
    setPresentActiveKey('Details');
    ResetFields();
  };

  dayjs.extend(utc);


  const editRecord = async (record, key) => {
    setPresentActiveKey('Details');
    setSelectedKey(key);
    let userList = await getUserList();
    setUserList(userList);
    let StatusList = await getStatusList(record.Status);
    setStatusList(StatusList);
    try {
      const editedRow = await getById(record.Id, 'Failure Reporting And Assignment');

      if (!editedRow || !editedRow[0]) {
        console.error('No record found');
        return;
      }
      let departmentList = await getDepartmentList();
      setDepartmentList(departmentList);
      if (editedRow && editedRow[0].DepartmentId) {
        let userList = await getUsersList(editedRow && editedRow[0].DepartmentId);
        setUsersList(userList);
      }
      let FailureCodeList = await getFailureCodeList(editedRow[0].Device);
      setFailureCodeList(FailureCodeList);
      // const questionsList = await getQuestionsList(editedRow[0].FailureTypeId);
      // setQuestionsList(questionsList);
      h1Ref.current &&
        h1Ref.current.setFieldsValue({
          Id: editedRow[0].Id,
          Device: editedRow[0].Device,
          FailureTypeId: editedRow[0].FailureTypeId,
          FaultCode: editedRow[0].FaultCode,
          Impact: editedRow[0].Impact,
          OccuranceCount: editedRow[0].OccuranceCount,
          Remarks: editedRow[0].Remarks,
          SeverityId: editedRow[0].SeverityId,
          OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
          ReportedDate: dayjs(editedRow[0].ReportedDate),
          FailureDescription: editedRow[0].FailureDescription,
          ReportedBy: editedRow[0].ReportedName,
          Comments: editedRow && editedRow[0] && editedRow[0].Comments,
          Status: editedRow && editedRow[0] && editedRow[0].Status,
          DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
          UserId: editedRow && editedRow[0] && editedRow[0].UserId
        });

      const updatedForm = {
        Id: editedRow[0].Id,
        Device: editedRow[0].Device,
        FailureTypeId: editedRow[0].FailureTypeId,
        FaultCode: editedRow[0].FaultCode,
        Impact: editedRow[0].Impact,
        OccuranceCount: editedRow[0].OccuranceCount,
        Remarks: editedRow[0].Remarks,
        SeverityId: editedRow[0].SeverityId,
        OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow[0].ReportedDate),
        FailureDescription: editedRow[0].FailureDescription,
        ReportedBy: editedRow[0].ReportedName,
        Attachments: editedRow[0].Attachments,
        Comments: editedRow && editedRow[0] && editedRow[0].Comments,
        Status: editedRow && editedRow[0] && editedRow[0].Status,
        Questions: editedRow && editedRow[0] && editedRow[0].Questions,
        DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        UserId: editedRow && editedRow[0] && editedRow[0].UserId,
        Department: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        User: editedRow && editedRow[0] && editedRow[0].UserId
      };
      setFailureTypeId(editedRow[0].FailureTypeId);
      setFormObject(updatedForm);
      setSelectedDevice(editedRow[0].Device);
      setStatus(editedRow[0].Status);
      const questionsList = await getQuestionsList(editedRow[0].FailureTypeId, editedRow[0].Device);
      setQuestionsList(questionsList);
      QuestionRef.current &&
        QuestionRef.current.setFieldsValue({
          Questions: editedRow[0].Questions
        });
      setQuestions(editedRow[0].Questions);
    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const AnalysisEdit = async (record, key) => {
    setPresentActiveKey('Details');
    setSelectedKey(key);

    try {
      // Fetch user and status lists
      const userList = await getUserList();
      setUserList(userList);

      const statusList = await getStatusList(record.Status);
      setStatusList(statusList);

      // Fetch analysis and corrective data
      const editedRow = await getAnalysisById(record.Id, 'Analysis and Corrective Actions');
      const correctiveEdit = await getCorrectiveById(record.Id);

      // Handle Corrective Edit
      if (correctiveEdit && correctiveEdit[0] && correctiveEdit[0].Id) {
        const correctiveData = correctiveEdit[0];
        await h4Ref.current?.setFieldsValue({
          ...correctiveData
          // Id: correctiveData.Id,
          // ChangeRecommendations: correctiveData.ChangeRecommendations,
          // CorrectiveActionType: correctiveData.CorrectiveActionType,
          // // CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          // ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          // PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          // VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveFormObject({
          ...correctiveData
          // Id: correctiveData.Id,
          // ChangeRecommendations: correctiveData.ChangeRecommendations,
          // CorrectiveActionType: correctiveData.CorrectiveActionType,
          // CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          // ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          // PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          // VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveButton(false);
        setCorrectiveStatus('Analysis Completed');
      } else {
        await h4Ref.current?.setFieldsValue({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveFormObject({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveButton(false);
        setCorrectiveStatus(null);
      }

      // If analysis record not found
      if (!editedRow) {
        console.error('No record found');
        return;
      }

      // Fetch failure code list
      const failureCodeList = await getFailureCodeList(editedRow.Device);
      setFailureCodeList(failureCodeList);

      // Fetch users list based on department
      if (editedRow.DepartmentId) {
        const departmentUsers = await getUsersList(editedRow.DepartmentId);
        setUsersList(departmentUsers);
      }

      // Set main form fields
      await h2Ref.current?.setFieldsValue({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.Status,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId,
        Attachments: editedRow.Attachments
      });

      setFormObject({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.Status,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId,
        Attachments: editedRow.Attachments
      });

      // Set analysis form fields
      if (editedRow.Id) {
        await h3Ref.current?.setFieldsValue({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments
        });

        setAnalysisFormObject({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          ChangeRecommendations: editedRow.ChangeRecommendations,
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments,
          AnalysisAttachments: editedRow.AnalysisAttachments
        });
      } else {
        await h3Ref.current?.setFieldsValue({
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });

        setAnalysisFormObject({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });
      }

      setFailureTypeId(editedRow.FailureTypeId);
      setSelectedDevice(editedRow.Device);

      // Fetch and set questions
      const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
      setQuestionsList(questionsList);

      await QuestionRef.current?.setFieldsValue({
        Questions: editedRow.Questions
      });
      setQuestions(editedRow.Questions);

    } catch (error) {
      console.error('Error editing record:', error);
    }
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const onFailureTypeChange = async (value) => {
    const questionsList = await getQuestionsList(value, selectedDevice);
    setQuestionsList(questionsList);
    setFailureTypeId(value);
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestionsData([]);
  };
  // const validateMessages = {
  //   required: translation('${label}') + translation('is required!')
  // };

  const formItemLayout = { width: '100%', flex: '50%' };

  const FailureReportColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchProps('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchProps('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      ...getColumnSearchProps('SeverityName')
    },
    // {
    //   title: translation('FR Count'),
    //   dataIndex: 'OccuranceCount',
    //   ...getColumnSearchProps('OccuranceCount')
    // },
    // {
    //   title: translation('Reported By'),
    //   dataIndex: 'ReportedBy',
    //   ...getColumnSearchProps('ReportedBy')
    // },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      ...getColumnSearchProps('DetectionSource')
    },
    {
      title: translation('Occured Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('OccuranceDate'),
      // render: (text) => (
      //   <div>{dayjs.utc(text, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')}</div>
      // )
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Created Date'),
      dataIndex: 'ReportedDate',
      key: 'ReportedDate',
      sorter: (a, b) => dayjs(a.ReportedDate) - dayjs(b.ReportedDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('ReportedDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      ...getColumnSearchProps('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          <Button type="primary" onClick={() => editRecord(record, 'edit')}>
            <Tooltip title={translation('Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];
  const FailureAnalysisColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchProps('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchProps('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      ...getColumnSearchProps('SeverityName')
    },
    // {
    //   title: translation('FR Count'),
    //   dataIndex: 'OccuranceCount',
    //   ...getColumnSearchProps('OccuranceCount')
    // },
    // {
    //   title: translation('Reported By'),
    //   dataIndex: 'ReportedBy',
    //   ...getColumnSearchProps('ReportedBy')
    // },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      ...getColumnSearchProps('DetectionSource')
    },
    {
      title: translation('Occured Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('OccuranceDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      ...getColumnSearchProps('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          <Button type="primary" onClick={() => AnalysisEdit(record, 'edit')}>
            <Tooltip title={translation('Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];
  const UseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <>
          <Tooltip placement="top" key="download" title="Download">
            <div style={{ marginLeft: '-25px' }}>
              <a href={`https://pam.bmecomosolution.com/api/fracasAttachments/${record.file}`}>
                {' '}
                <DownloadOutlined style={{ color: '#1a91ff' }} />
              </a>
            </div>
          </Tooltip>
        </>
      )
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  // const selectedRolesList = ['Reporting', 'Failure Reporting And Assignment'];
  return (
    <div style={{ minHeight: window.innerHeight - 69, paddingLeft: '40px', paddingRight: '40px' }}>
      <Tabs
        defaultActiveKey="Reporting"
        activeKey={parentPresentActiveKey}
        onChange={async (activeKey) => {
          let data = [];
          if (activeKey && activeKey === "Analysis and Corrective Actions") {
            data = await getAnalysisList('Analysis and Corrective Actions');
          } else {
            data = await getList(activeKey);
          }

          setDataSource(data);
          setParentPresentActiveKey(activeKey);
          setPresentActiveKey('List');
          ResetFields();
          correctiveResetFields();
        }}
        type="card"
        className="TabsText"
      >

        {selectedRolesList && selectedRolesList.includes('Failure Reporting And Assignment') ? (
          <TabPane tab={translation('Failure Reporting And Assignment')} key="Failure Reporting And Assignment">
            <Tabs
              defaultActiveKey="List"
              activeKey={presentActiveKey}
              onChange={(activeKey) => {
                setPresentActiveKey('List');
                reportingResetFields();
              }}
            >
              <TabPane tab={'List'} key="List">
                <Button
                  type="primary"
                  onClick={addNew}
                  style={{
                    background: '#214972',
                    marginBottom: '10px',
                    float: 'right',
                    marginTop: '5px'
                  }}
                >
                  <PlusOutlined /> Add
                </Button>
                <StyledTable size="small"
                  columns={FailureReportColumns}
                  dataSource={dataSource}
                  style={{ marginTop: '24px' }}
                />
              </TabPane>
              <TabPane tab={'Details'} key="Details">
                <Form
                  name="FailureReport"
                  ref={h1Ref}
                  form={form}
                  autoComplete="off"
                  initialValues={formObject}
                  layout="horizontal"
                  labelCol={{ flex: '160px' }}
                  labelAlign="right"
                  onFinish={onReportFormSubmit}
                  onFinishFailed={onFinishFailed}
                  labelWrap
                  // validateMessages={validateMessages}
                  wrapperCol={{ flex: 1 }}
                >
                  <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px' }}>
                    <Form.Item name="Id"></Form.Item>

                    <Form.Item
                      name="Device"
                      label={translation(`Equipment`)}
                      rules={[
                        {
                          required: true,
                          message: translation("Please Select Equipment!"),
                        },
                      ]}
                      style={formItemLayout}
                    >
                      <>
                        <Select
                          style={{
                            width: '62%'
                          }}
                          value={selectedDevice}
                          // mode="multiple"
                          placeholder={translation('Select Equipment')}

                          disabled={true}
                        >
                          {devicesList &&
                            Array.isArray(devicesList) &&
                            devicesList.map((eqp, index) => {
                              return (
                                <Option key={index} value={eqp.AliasCode}>
                                  {`${eqp.DisplayCode}`}
                                </Option>
                              );
                            })}
                        </Select>
                      </>

                      <Button
                        type="primary"
                        onClick={() => {
                          setTreeVisible(true);
                        }}
                        disabled={formObject.Id}
                      >
                        <UpSquareOutlined />
                      </Button>
                    </Form.Item>

                    <Form.Item
                      label={translation('Fault Code')}
                      name="FaultCode"
                      style={formItemLayout}
                      rules={[
                        {
                          required: true,
                          message: translation("Please Select Fault Code!"),
                        },
                      ]}

                    >
                      <Select
                        disabled={formObject.Status === 'Open' ? false : true}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Fault Code')}
                      >
                        {FailureCodeList &&
                          Array.isArray(FailureCodeList) &&
                          FailureCodeList.map((FailureCode, index) => {
                            return (
                              <Option key={index} value={FailureCode.VendorCode}>
                                {FailureCode.ParameterDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Type')}
                      name='FailureTypeId'
                      rules={[
                        {
                          required: true,
                          message: translation("Please Select Failure Type!"),
                        },
                      ]}
                      style={formItemLayout}
                    >
                      <Select
                        disabled={formObject.Status === 'Open' && selectedDevice ? false : true}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Failure Type')}

                        onChange={onFailureTypeChange}
                      >
                        {FailureTypeList &&
                          Array.isArray(FailureTypeList) &&
                          FailureTypeList.map((device, index) => {
                            return (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Description')}
                      name="FailureDescription"
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject.Status === 'Open' ? false : true}
                        placeholder={translation('Failure Description')}
                        style={{ width: '70%' }}
                      />
                    </Form.Item>
                    <Form.Item
                      label={translation('Severity')}
                      name="SeverityId"
                      style={formItemLayout}
                      rules={[
                        {
                          required: true,
                          message: translation("Please Select Severity!"),
                        },
                      ]}
                    >
                      <Select
                        disabled={formObject.Status === 'Open' ? false : true}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Severity')}

                      >
                        {SeverityList &&
                          Array.isArray(SeverityList) &&
                          SeverityList.map((device, index) => {
                            return (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Impact')}
                      name="Impact"
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject.Status === 'Open' ? false : true}
                        placeholder={translation('Add Failure Impact')}
                        style={{ width: '70%' }}
                      />
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Occured Date&Time')}
                      name="OccuranceDate"
                      style={formItemLayout}
                      rules={[
                        {
                          required: true,
                          message: translation("Please Select Failure Occured Date&Time!"),
                        },
                      ]}
                    >
                      <DatePicker
                        disabled={formObject.Status === 'Open' ? false : true}
                        showTime={{ format: 'HH:mm:ss' }}
                        placeholder="Select Occurance Date"
                        inputReadOnly={true}
                        style={{ width: '70%' }}
                        format="YYYY-MM-DD HH:mm:ss"
                        disabledDate={disabledDate}
                      />
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Reported Date')}
                      name="ReportedDate"
                      style={formItemLayout}
                    >
                      <DatePicker
                        format={'YYYY-MM-DD HH:mm:ss'}
                        style={{ width: '70%' }}
                        disabled={true}
                        placeholder={translation('Failure Reported Date')}
                      />
                    </Form.Item>
                    <Form.Item
                      label={translation('Failure Occurence Count')}
                      name="OccuranceCount"
                      style={formItemLayout}
                      rules={[
                        {
                          required: true,
                          message: translation("Please input Failure Occurence Count!"),
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        min={0} max={100000}
                        onKeyDown={(e) => {
                          if ([8].includes(e.keyCode)) {
                            return;
                          }
                          if (
                            (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                            (e.keyCode < 96 || e.keyCode > 105)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        disabled={formObject.Status === 'Open' ? false : true}
                        placeholder={translation('Failure Occurence Count')}
                        style={{ width: '70%' }}
                      />
                    </Form.Item>
                    {/* <Form.Item label={translation('Remarks')} name="Remarks" style={formItemLayout}>
                      <Input
                        placeholder={translation('Add Remarks')}
                        style={{ width: '70%' }}
                        disabled={formObject.Status === 'Open' ? false : true}
                      />
                    </Form.Item> */}

                    <Form.Item
                      style={formItemLayout}
                      name="Attachments"
                      label={translation('Attachments')}
                    >
                      <Select
                        disabled={formObject.Status === 'Open' ? false : true}

                        style={{ width: '70%' }}
                        placeholder={'Add/View Attachments'}
                        onSelect={handleClick}
                      >
                        <Option key={'View Attachments'} value={'View Attachments'}>
                          View Attachments
                        </Option>
                        <Option key={'Add New Attachments'} value={'Add New Attachments'}>
                          Add New Attachments
                        </Option>
                      </Select>
                      <Upload
                        // accept="text/csv"
                        multiple={true}
                        beforeUpload={(file) => {
                          const isCSV =
                            file.type === 'image/jpeg' ||
                            file.name.endsWith('.jpg') ||
                            file.name.endsWith('.jpeg') ||
                            file.name.endsWith('.pdf') ||
                            file.name.endsWith('.png') ||
                            file.name.endsWith('.ppt') ||
                            file.name.endsWith('.pptx') ||
                            file.name.endsWith('.xls') ||
                            file.name.endsWith('.xlsx') ||
                            file.name.endsWith('.docx') ||
                            file.name.endsWith('.doc')
                            ;
                          if (!isCSV) {
                            message.error(`You can not upload ${file.type} files!`);
                          }
                          const isLt2M = file.size / 1024 / 1024 < 2;
                          if (!isLt2M) {
                            message.error('File must be smaller than 2MB!');
                          }
                          return isCSV && isLt2M;
                        }}
                        //   beforeUpload={beforeUpload}
                        // beforeUpload={this.filebeforeUpload}
                        // ref={this.myRef}
                        onChange={(info) => fileUpload(info)}
                        action={`/api/fracas/reporting/saveFile?SiteId=${siteId}&Type=${'fracas'}&Source=${'Reporting'}`}
                        headers={{
                          Authorization: Authorization
                        }}
                        showUploadList={false}
                      >
                        <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                          <UploadOutlined /> Upload
                        </Button>
                      </Upload>
                      <Drawer
                        title="Failure Report Uploaded Files"
                        open={showusecasedownloadModal}
                        width={'50%'}
                        onOk={() => setShowusecasedownloadModal(false)}
                        onClose={() => setShowusecasedownloadModal(false)}
                      >
                        <StyledTable size="small"
                          columns={UseCaseColumns}
                          dataSource={
                            formObject &&
                              formObject.Attachments &&
                              Array.isArray(formObject.Attachments) &&
                              formObject.Attachments
                              ? [...formObject.Attachments]
                              : []
                          }
                        />
                      </Drawer>
                    </Form.Item>
                    <Form.Item
                      label={translation('Reported By')}
                      name="ReportedBy"
                      style={formItemLayout}
                    >
                      <Select
                        disabled={true}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Reported By')}

                      >
                        {userList &&
                          Array.isArray(userList) &&
                          userList.map((user, index) => {
                            return (
                              <Option key={index} value={user.Id}>
                                {user.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    {/* {formObject && formObject.Id ?
              <>
                    <Form.Item label={translation('Department')} name="DepartmentId" style={formItemLayout}>
                      <Select
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Department')}
                        
                      >
                        {departmentList &&
                          Array.isArray(departmentList) &&
                          departmentList.map((department, index) => {
                            return (
                              <Option key={index} value={department.Id}>
                                {department.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item label={translation('Assigned To')} name="assignedTo" style={formItemLayout}>
                      <Select
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Assigned To')}
                        
                      >
                        {usersList &&
                          Array.isArray(usersList) &&
                          usersList.map((user, index) => {
                            return (
                              <Option key={index} value={user.Id}>
                                {user.FirstName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    </>
              :null } */}
                    <Form.Item
                      label={translation('Comments')}
                      name="Comments"
                      // rules={[{ required: true }]}z
                      style={formItemLayout}
                    >
                      <Input
                        placeholder={translation('Add Comments')}
                        style={{ width: '70%' }}
                        disabled={formObject.Status === 'Open' ? false : true}
                      />
                    </Form.Item>
                    <Form.Item label={translation('Status')} name="Status" style={formItemLayout}>
                      <Select
                        disabled={!formObject.Id}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Status')}
                        onChange={onStatusChange}
                      >
                        {statusList &&
                          Array.isArray(statusList) &&
                          statusList.map((status, index) => {
                            return (
                              <Option key={index} value={status.NextStatus}>
                                {status.NextStatus}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Department')}
                      name="DepartmentId"
                      style={formItemLayout}
                    >
                      <Select
                        disabled={status === 'Open'}
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Department')}

                        onChange={onChangeDepartment}
                      >
                        {departmentList &&
                          Array.isArray(departmentList) &&
                          departmentList.map((department, index) => {
                            return (
                              <Option key={index} value={department.Id}>
                                {department.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Assigned To')}
                      name="UserId"
                      style={formItemLayout}
                    >
                      <Select
                        disabled={status === 'Open'}
                        style={{
                          width: '31%'
                        }}
                        placeholder={translation('Select Assigned To')}

                      >
                        {usersList &&
                          Array.isArray(usersList) &&
                          usersList.map((user, index) => {
                            return (
                              <Option key={index} value={`${user.Id}_${user.RoleId}`}>
                                {user.UserName_Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>

                    <div
                      style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                      theme={themeSettings}
                    >
                      <Collapse
                        // activeKey={this.state.openPanels}
                        defaultActiveKey={['1', '2', '3']}
                        style={{ width: '1400px' }}
                        expandIcon={({ isActive }) =>
                          isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                        }
                      // onChange={this.onCollapseChange}
                      >
                        <Panel header="Questions" key="1">
                          <Form
                            name="dynamic_form_nest_item"
                            autoComplete="off"
                            ref={QuestionRef}
                            initialValues={{ Questions: Questions }}
                            style={{ paddingLeft: '5%', marginBottom: '5%' }}
                            layout="vertical"
                            className="Answers_Form"
                          >
                            <Form.List name="Questions">
                              {(fields, { add, remove }) => (
                                <>
                                  {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                      key={key}
                                      style={{
                                        display: 'flex',
                                        marginBottom: 50
                                      }}
                                      align="baseline"
                                    >
                                      <Form.Item
                                        label="Question"
                                        {...restField}
                                        name={[name, 'QuestionId']}
                                        rules={1[
                                          {
                                            required: true,
                                            message: 'Missing Question'
                                          }
                                        ]}
                                      >
                                        <Select
                                          placeholder="Please select Question"
                                          // maxTagCount={1}
                                          style={{ width: '350px' }}
                                        // disabled={formObject.Id}
                                        >
                                          {questionsList &&
                                            Array.isArray(questionsList) &&
                                            questionsList.map((item, index) => {
                                              return (
                                                <option key={index} value={item.Id}>
                                                  {item.Question}
                                                </option>
                                              );
                                            })}
                                        </Select>
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        label="Answer"
                                        name={[name, 'Answers']}
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Missing Answer'
                                          }
                                        ]}
                                      >
                                        <Input
                                          // disabled={formObject.Id}
                                          placeholder="Please add Answer"
                                          style={{ width: '350px' }}
                                        />
                                      </Form.Item>

                                      {/* {!formObject.Id ? ( */}
                                      <MinusCircleOutlined onClick={() => remove(name)} />
                                      {/* ) : null} */}
                                    </Space>
                                  ))}

                                  <Form.Item style={{ marginTop: '20px' }}>
                                    <Button
                                      type="dashed"
                                      style={{ width: '500px' }}
                                      onClick={() => add()}
                                      block
                                      icon={<PlusOutlined />}
                                      disabled={
                                        selectedDevice === null ||
                                          failureTypeId === null
                                          // ||
                                          // formObject.Id
                                          ? true
                                          : false
                                      }
                                    >
                                      Add Question
                                    </Button>
                                  </Form.Item>
                                </>
                              )}
                            </Form.List>
                          </Form>
                        </Panel>
                      </Collapse>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'right',
                      paddingRight: '5%',
                      paddingTop: '2%'
                    }}
                  >
                    {/* <Form.Item>
                      <Button
                        type="primary"
                        style={{ marginRight: 8 }}
                        onClick={() => {
                          setQuestionVisible(true);
                          QuestionRef.current &&
                            QuestionRef.current.setFieldsValue({
                              Questions: formObject.Questions || []
                            });
                          setQuestions(formObject.Questions || []);
                        }}
                        disabled={selectedDevice === null || failureTypeId === null ? true : false}
                      >
                        Questionnaire Form
                      </Button>
                    </Form.Item> */}
                    <Form.Item>
                      <Button type="primary" style={{ marginRight: 8 }} htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel}>
                        Cancel
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </TabPane>
            </Tabs>
          </TabPane>
        ) : null}
        {selectedRolesList && selectedRolesList.includes('Analysis and Corrective Actions') ? (
          <TabPane tab={translation('Analysis and Corrective Actions')} key="Analysis and Corrective Actions">
            <Tabs
              defaultActiveKey="List"
              activeKey={presentActiveKey}
              onChange={(activeKey) => {
                setPresentActiveKey('List');
                analysisResetFields();
              }}
            >
              <TabPane tab={'List'} key="List">
                {/* <Button
                  type="primary"
                  onClick={addNew2}
                  style={{
                    background: '#214972',
                    marginBottom: '10px',
                    float: 'right',
                    marginTop: '5px'
                  }}
                >
                  <PlusOutlined /> Add
                </Button> */}
                <StyledTable size="small"
                  columns={FailureAnalysisColumns}
                  dataSource={dataSource}
                  style={{ marginTop: '24px' }}
                />
              </TabPane>
              <TabPane tab={'Details'} key="Details">
                <Form
                  name="FailureReport"
                  ref={h2Ref}
                  autoComplete="off"
                  initialValues={formObject}
                  layout="horizontal"
                  labelCol={{ flex: '160px' }}
                  labelAlign="right"
                  onFinish={onAnalysisFormSubmit}
                  // onFinishFailed={onFi-nishFailed}
                  labelWrap
                  // validateMessages={validateMessages}
                  wrapperCol={{ flex: 1 }}
                >
                  <div
                    style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                    theme={themeSettings}
                  >
                    <Collapse
                      // activeKey={this.state.openPanels}
                      defaultActiveKey={['1']}
                      style={{ width: '1500px' }}
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                      }
                    // onChange={this.onCollapseChange}
                    >
                      <Panel header="Reporting Details" key="1">

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px' }}>
                          <Form.Item name="Id"></Form.Item>

                          <Form.Item
                            name={'Device'}
                            label={translation(`Equipment`)}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Equipment!"),
                              },
                            ]}
                            style={formItemLayout}
                          >
                            <>
                              <Select
                                style={{
                                  width: '62%'
                                }}
                                value={selectedDevice}
                                // mode="multiple"
                                placeholder={translation('Select Equipment')}

                                disabled={true}
                              >
                                {devicesList &&
                                  Array.isArray(devicesList) &&
                                  devicesList.map((eqp, index) => {
                                    return (
                                      <Option key={index} value={eqp.AliasCode}>
                                        {`${eqp.DisplayCode}`}
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </>

                            <Button
                              type="primary"
                              onClick={() => {
                                setTreeVisible(true);
                              }}
                              disabled={formObject.Id}
                            >
                              <UpSquareOutlined />
                            </Button>
                          </Form.Item>
                          <Form.Item
                            label={translation('Fault Code')}
                            name="FaultCode"
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Fault Code!"),
                              },
                            ]}
                            style={formItemLayout}
                          >
                            <Select
                              style={{
                                width: '70%'
                              }}
                              disabled={formObject.Id}
                              // value={selectedDevice}
                              // mode="multiple"
                              placeholder={translation('Select Fault Code')}
                              size="default"
                            // disabled={true}
                            >
                              {FailureCodeList &&
                                Array.isArray(FailureCodeList) &&
                                FailureCodeList.map((FailureCode, index) => {
                                  return (
                                    <Option key={index} value={FailureCode.VendorCode}>
                                      {FailureCode.ParameterDescription}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Type')}
                            name="FailureTypeId"
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Failure Type!"),
                              },
                            ]}
                            style={formItemLayout}
                          >
                            <Select
                              disabled={formObject.Id}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Failure Type')}

                            // onChange={onFailureTypeChange}
                            >
                              {FailureTypeList &&
                                Array.isArray(FailureTypeList) &&
                                FailureTypeList.map((device, index) => {
                                  return (
                                    <Option key={index} value={device.Id}>
                                      {device.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Description')}
                            name="FailureDescription"
                            style={formItemLayout}
                          >
                            <Input
                              disabled={formObject.Id}
                              placeholder={translation('Failure Description')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation('Severity')}
                            name="SeverityId"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={formObject.Id}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Severity')}
                              rules={[
                                {
                                  required: true,
                                  message: translation("Please Select Severity!"),
                                },
                              ]}
                            >
                              {SeverityList &&
                                Array.isArray(SeverityList) &&
                                SeverityList.map((device, index) => {
                                  return (
                                    <Option key={index} value={device.Id}>
                                      {device.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Impact')}
                            name="Impact"
                            style={formItemLayout}
                          >
                            <Input
                              disabled={formObject.Id}
                              placeholder={translation('Add Failure Impact')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Occured Date&Time')}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Failure Occured Date&Time!"),
                              },
                            ]}
                            name="OccuranceDate"
                            style={formItemLayout}
                          >
                            <DatePicker
                              disabled={formObject.Id}
                              showTime={{ format: 'HH:mm' }}
                              placeholder="Select Occurance Date"
                              inputReadOnly={true}
                              style={{ width: '70%' }}
                              format="YYYY-MM-DD HH:mm:ss"
                              disabledDate={disabledDate}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Reported Date')}
                            name="ReportedDate"
                            style={formItemLayout}
                          >
                            <DatePicker
                              format={'YYYY-MM-DD HH:mm:ss'}
                              style={{ width: '70%' }}
                              disabled={true}
                              placeholder={translation('Failure Reported Date')}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation('Failure Occurence Count')}
                            name="OccuranceCount"
                            style={formItemLayout}
                            rules={[
                              {
                                required: true,
                                message: translation("Please input Failure Occurence Count!"),
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              onKeyDown={(e) => {
                                if ([8].includes(e.keyCode)) {
                                  return;
                                }
                                if (
                                  (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                  (e.keyCode < 96 || e.keyCode > 105)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              disabled={formObject.Id}
                              placeholder={translation('Failure Occurence Count')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                          {/* <Form.Item label={translation('Remarks')} name="Remarks" style={formItemLayout}>
                            <Input
                              placeholder={translation('Add Remarks')}
                              style={{ width: '70%' }}
                              disabled={formObject.Id}
                            />
                          </Form.Item> */}

                          <Form.Item
                            style={formItemLayout}
                            name="Attachments"
                            label={translation('Attachments')}
                          >
                            <Select
                              // disabled={formObject.Id}

                              style={{ width: '70%' }}
                              placeholder={'Add/View Attachments'}
                              onSelect={handleClick}
                            >
                              <Option key={'View Attachments'} value={'View Attachments'}>
                                View Attachments
                              </Option>
                              {/* <Option key={'Add New Attachments'} value={'Add New Attachments'}>
                                Add New Attachments
                              </Option> */}
                            </Select>
                            <Upload
                              // accept="text/csv"
                              multiple={true}
                              beforeUpload={beforeUpload}
                              // beforeUpload={this.filebeforeUpload}
                              // ref={this.myRef}
                              onChange={(info) => fileUpload(info)}
                              action={`/api/fracas/reporting/saveFile?SiteId=${siteId}&Type=${'fracas'}&Source=${'Reporting'}`}
                              headers={{
                                Authorization: Authorization
                              }}
                              showUploadList={false}
                            >
                              <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                <UploadOutlined /> Upload
                              </Button>
                            </Upload>
                            <Drawer
                              title="Failure Report Uploaded Files"
                              open={showusecasedownloadModal}
                              width={'50%'}
                              onOk={() => setShowusecasedownloadModal(false)}
                              onClose={() => setShowusecasedownloadModal(false)}
                            >
                              <StyledTable size="small"
                                columns={UseCaseColumns}
                                dataSource={
                                  formObject &&
                                    formObject.Attachments &&
                                    Array.isArray(formObject.Attachments) &&
                                    formObject.Attachments
                                    ? [...formObject.Attachments]
                                    : []
                                }
                              />
                            </Drawer>
                          </Form.Item>
                          <Form.Item
                            label={translation('Reported By')}
                            name="ReportedBy"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={true}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Reported By')}

                            >
                              {userList &&
                                Array.isArray(userList) &&
                                userList.map((user, index) => {
                                  return (
                                    <Option key={index} value={user.Id}>
                                      {user.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          {/* {formObject && formObject.Id ?
              <>
                    <Form.Item label={translation('Department')} name="DepartmentId" style={formItemLayout}>
                      <Select
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Department')}
                        
                      >
                        {departmentList &&
                          Array.isArray(departmentList) &&
                          departmentList.map((department, index) => {
                            return (
                              <Option key={index} value={department.Id}>
                                {department.Name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item label={translation('Assigned To')} name="assignedTo" style={formItemLayout}>
                      <Select
                        style={{
                          width: '70%'
                        }}
                        placeholder={translation('Select Assigned To')}
                        
                      >
                        {usersList &&
                          Array.isArray(usersList) &&
                          usersList.map((user, index) => {
                            return (
                              <Option key={index} value={user.Id}>
                                {user.FirstName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    </>
              :null } */}
                          <Form.Item
                            label={translation('Comments')}
                            name="Comments"
                            // rules={[{ required: true }]}
                            style={formItemLayout}
                          >
                            <Input
                              placeholder={translation('Add Comments')}
                              style={{ width: '70%' }}
                              disabled={formObject.Id}
                            />
                          </Form.Item>
                          <Form.Item label={translation('Status')} name="Status" style={formItemLayout}>
                            <Select
                              // disabled={formObject.Id}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Status')}
                              onChange={onStatusChange}
                            >
                              {statusList &&
                                Array.isArray(statusList) &&
                                statusList.map((status, index) => {
                                  return (
                                    <Option key={index} value={status.NextStatus}>
                                      {status.NextStatus}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation('Department')}
                            name="DepartmentId"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={formObject.Id}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Department')}

                              onChange={onChangeDepartment}
                            >
                              {departmentList &&
                                Array.isArray(departmentList) &&
                                departmentList.map((department, index) => {
                                  return (
                                    <Option key={index} value={department.Id}>
                                      {department.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation('Assigned To')}
                            name="UserId"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={formObject.Id}
                              style={{
                                width: '31%'
                              }}
                              placeholder={translation('Select Assigned To')}

                            >
                              {usersList &&
                                Array.isArray(usersList) &&
                                usersList.map((user, index) => {
                                  return (
                                    <Option key={index} value={`${user.Id}_${user.RoleId}`}>
                                      {user.UserName_Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>

                          <div
                            style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                            theme={themeSettings}
                          >
                            <Collapse
                              // activeKey={this.state.openPanels}
                              defaultActiveKey={['1', '2', '3']}
                              style={{ width: '1400px' }}
                              expandIcon={({ isActive }) =>
                                isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                              }
                            // onChange={this.onCollapseChange}
                            >
                              <Panel header="Questions" key="1">
                                <Form
                                  name="dynamic_form_nest_item"
                                  autoComplete="off"
                                  ref={QuestionRef}
                                  initialValues={{ Questions: Questions }}
                                  style={{ paddingLeft: '5%', marginBottom: '5%' }}
                                  layout="vertical"
                                  className="Answers_Form"
                                >
                                  <Form.List name="Questions">
                                    {(fields, { add, remove }) => (
                                      <>
                                        {fields.map(({ key, name, ...restField }) => (
                                          <Space
                                            key={key}
                                            style={{
                                              display: 'flex',
                                              marginBottom: 20
                                            }}
                                            align="baseline"
                                          >
                                            <Form.Item
                                              label="Question"
                                              {...restField}
                                              name={[name, 'QuestionId']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Missing Question'
                                                }
                                              ]}
                                            >
                                              <Select
                                                placeholder=" Question"
                                                // maxTagCount={1}
                                                style={{ width: '350px' }}
                                                disabled={formObject.Id}
                                              >
                                                {questionsList &&
                                                  Array.isArray(questionsList) &&
                                                  questionsList.map((item, index) => {
                                                    return (
                                                      <option key={index} value={item.Id}>
                                                        {item.Question}
                                                      </option>
                                                    );
                                                  })}
                                              </Select>
                                            </Form.Item>

                                            <Form.Item
                                              {...restField}
                                              label="Answer"
                                              name={[name, 'Answers']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Missing Answer'
                                                }
                                              ]}
                                            >
                                              <Input
                                                disabled={formObject.Id}
                                                placeholder="Answer"
                                                style={{ width: '350px' }}
                                              />
                                            </Form.Item>
                                            {!formObject.Id ? (
                                              <MinusCircleOutlined onClick={() => remove(name)} />
                                            ) : null}
                                          </Space>
                                        ))}
                                        <Form.Item style={{ marginTop: '20px' }}>
                                          <Button
                                            type="dashed"
                                            style={{ width: '500px' }}
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                            disabled={
                                              selectedDevice === null ||
                                                failureTypeId === null ||
                                                formObject.Id
                                                ? true
                                                : false
                                            }
                                          >
                                            Add Question
                                          </Button>
                                        </Form.Item>
                                      </>
                                    )}
                                  </Form.List>
                                </Form>
                              </Panel>
                            </Collapse>
                          </div>
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                  {/* <div> */}
                  <div
                    style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                    theme={themeSettings}
                  >
                    <Collapse
                      // activeKey={this.state.openPanels}
                      defaultActiveKey={['1']}
                      style={{ width: '1500px' }}
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                      }
                    // onChange={this.onCollapseChange}
                    >
                      <Panel header="Analysis Details" key="1">

                        <Form
                          name="FailureReport"
                          ref={h3Ref}
                          autoComplete="off"
                          initialValues={analysisFormObject}
                          layout="horizontal"
                          labelCol={{ flex: '200px' }}
                          labelAlign="right"
                          // onFinish={onAnalysisFormSubmit}
                          // onFinishFailed={onFi-nishFailed}
                          labelWrap
                          // validateMessages={validateMessages}
                          wrapperCol={{ flex: 1 }}
                        >
                          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px' }}>
                            <Form.Item name="Id"></Form.Item>

                            <Form.Item
                              name="AnalysisStartDate"
                              label={translation(`Analysis Start Date`)}
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: translation("Please Select Equipment!"),
                              //   },
                              // ]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                showTime={true}
                                showNow={false}
                                // disabled={formObject.Id}
                                placeholder="Select Analysis Start Date"
                                inputReadOnly={true}
                                style={{ width: '70%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                disabledDate={(d) =>
                                  !d ||
                                  d.isBefore(h2Ref.current &&
                                    h2Ref.current.getFieldValue() &&
                                    h2Ref.current.getFieldValue()['ReportedDate']
                                    ? dayjs(
                                      h2Ref.current.getFieldValue()['ReportedDate']
                                    ).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                                    : ''
                                  )}
                                disabledTime={(current) => {
                                  let FromTime = h2Ref.current?.getFieldValue('ReportedDate');

                                  let currentTime = dayjs();
                                  if (!FromTime || !current) {
                                    return {};
                                  }
                                  const disabledHours = [];
                                  const disabledMinutes = [];
                                  const disabledSeconds = [];
                                  if (current.isSame(FromTime, 'day')) {
                                    for (let i = 0; i < FromTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === FromTime.hour()) {
                                      for (let i = 0; i < FromTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === FromTime.minute()) {
                                        for (let i = 0; i < FromTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  if (current.isSame(currentTime, 'day')) {
                                    for (let i = 0; i < currentTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === currentTime.hour()) {
                                      for (let i = 0; i < currentTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === currentTime.minute()) {
                                        for (let i = 0; i < currentTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes: () => disabledMinutes,
                                    disabledSeconds: () => disabledSeconds
                                  };
                                }}
                              // ||
                              // d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))

                              />
                            </Form.Item>
                            <Form.Item
                              label={translation('Analysis Due Date')}
                              name="AnalysisDueDate"
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                showTime={true}
                                showNow={false}
                                // disabled={formObject.Id}
                                placeholder="Select Analysis Due Date"
                                inputReadOnly={true}
                                style={{ width: '70%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                disabledDate={(d) =>
                                  !d
                                  ||
                                  d.isBefore(h3Ref.current &&
                                    h3Ref.current.getFieldValue() &&
                                    h3Ref.current.getFieldValue()['AnalysisStartDate']
                                    ? dayjs(h3Ref.current.getFieldValue()['AnalysisStartDate'])
                                      .subtract(1, 'day')
                                      .format('YYYY-MM-DD HH:mm:ss')
                                    : ''
                                  )
                                  // ||
                                  // d.isBefore(h2Ref.current &&
                                  //   h2Ref.current.getFieldValue() &&
                                  //   h2Ref.current.getFieldValue()['ReportedDate']
                                  //   ? dayjs(
                                  //     h2Ref.current.getFieldValue()['ReportedDate']
                                  //   ).format('YYYY-MM-DD HH:mm:ss')
                                  //   : ''
                                  // )
                                  //  ||
                                  //  d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                                }
                                disabledTime={(current) => {
                                  let FromTime = h3Ref.current?.getFieldValue('AnalysisStartDate');

                                  let currentTime = dayjs();
                                  if (!FromTime || !current) {
                                    return {};
                                  }
                                  const disabledHours = [];
                                  const disabledMinutes = [];
                                  const disabledSeconds = [];
                                  if (current.isSame(FromTime, 'day')) {
                                    for (let i = 0; i < FromTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === FromTime.hour()) {
                                      for (let i = 0; i < FromTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === FromTime.minute()) {
                                        for (let i = 0; i < FromTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  if (current.isSame(currentTime, 'day')) {
                                    for (let i = 0; i < currentTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === currentTime.hour()) {
                                      for (let i = 0; i < currentTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === currentTime.minute()) {
                                        for (let i = 0; i < currentTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes: () => disabledMinutes,
                                    disabledSeconds: () => disabledSeconds
                                  };
                                }}
                              />
                            </Form.Item>
                            {/* <Form.Item
                          label={translation('Warranty Expiry Date')}
                          name="WarrantyExpiryDate"
                          // rules={[{ required: true }]}
                          style={formItemLayout}
                        >
                          <DatePicker
                            // disabled={formObject.Id}
                            showTime={true}
                            placeholder="Select Warranty Expiry Date"
                            inputReadOnly={true}
                            style={{ width: '70%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation('Sent Date to Vendor')}
                          name="SentDatetoVendor"
                          // rules={[{ required: true }]}
                          style={formItemLayout}
                        >
                          <DatePicker
                            showTime={true}
                            // disabled={formObject.Id}
                            placeholder="Select sent Date"
                            inputReadOnly={true}
                            style={{ width: '70%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                          />
                        </Form.Item> */}
                            {/* <Form.Item
                          label={translation('Change Recommendations')}
                          name="ChangeRecommendations"
                          // rules={[{ required: true }]}
                          style={formItemLayout}
                        >
                          <Select
                            style={{
                              width: '70%'
                            }}
                            placeholder="Select Change Recommendations"
                          >
                            <Option value={'SECP'}>Software Engineering Change Proposal</Option>
                            <Option value={'HECP'}>Hardware Engineering Change Proposal</Option>
                          </Select>
                        </Form.Item> */}
                            <Form.Item
                              label={translation('Failure Cause')}
                              name="FailureCause"
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input
                                placeholder="Input Failure Cause"
                                style={{
                                  width: '70%'
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label={translation('Contributing Factors')}
                              name="ContributingFactors"
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input
                                placeholder="Input Contributing Factors"
                                style={{
                                  width: '70%'
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label={translation('Analysis Description')}
                              name="AnalysisComments"
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input
                                placeholder="Input Analysis Description"
                                style={{
                                  width: '70%'
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              style={formItemLayout}
                              name="AnalysisAttachments"
                              label={translation('Analysis Attachments')}
                            >
                              <Select
                                // disabled={formObject.Status === 'Open' ? false : true}

                                style={{ width: '70%' }}
                                placeholder={'Add/View Attachments'}
                                onSelect={analysisHandleClick}
                              >
                                <Option key={'View Attachments'} value={'View Attachments'}>
                                  View Attachments
                                </Option>
                                <Option key={'Add New Attachments'} value={'Add New Attachments'}>
                                  Add New Attachments
                                </Option>
                              </Select>
                              <Upload
                                // accept="text/csv"
                                multiple={true}
                                beforeUpload={(file) => {
                                  const isCSV =
                                    file.type === 'image/jpeg' ||
                                    file.name.endsWith('.jpg') ||
                                    file.name.endsWith('.jpeg') ||
                                    file.name.endsWith('.pdf') ||
                                    file.name.endsWith('.png') ||
                                    file.name.endsWith('.ppt') ||
                                    file.name.endsWith('.pptx') ||
                                    file.name.endsWith('.xls') ||
                                    file.name.endsWith('.xlsx') ||
                                    file.name.endsWith('.docx') ||
                                    file.name.endsWith('.doc')
                                    ;
                                  if (!isCSV) {
                                    message.error(`You can not upload ${file.type} files!`);
                                  }
                                  const isLt2M = file.size / 1024 / 1024 < 2;
                                  if (!isLt2M) {
                                    message.error('File must be smaller than 2MB!');
                                  }
                                  return isCSV && isLt2M;
                                }}
                                //   beforeUpload={beforeUpload}
                                // beforeUpload={this.filebeforeUpload}
                                // ref={this.myRef}
                                onChange={(info) => analysisFileUpload(info)}
                                action={`/api/fracas/reporting/saveFile?SiteId=${siteId}&Type=${'fracas'}&Source=${'Analysis'}`}
                                headers={{
                                  Authorization: Authorization
                                }}
                                showUploadList={false}
                              >
                                <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                  <UploadOutlined /> Upload
                                </Button>
                              </Upload>
                              <Drawer
                                title="Failure Analysis Uploaded Files"
                                open={analysisShowusecasedownloadModal}
                                width={'50%'}
                                onOk={() => setAnalysisShowusecasedownloadModal(false)}
                                onClose={() => setAnalysisShowusecasedownloadModal(false)}
                              >
                                <StyledTable size="small"
                                  columns={UseCaseColumns}
                                  dataSource={
                                    analysisFormObject &&
                                      analysisFormObject.AnalysisAttachments &&
                                      Array.isArray(analysisFormObject.AnalysisAttachments) &&
                                      analysisFormObject.AnalysisAttachments
                                      ? [...analysisFormObject.AnalysisAttachments]
                                      : []
                                  }
                                />
                              </Drawer>
                            </Form.Item>
                          </div>
                        </Form>
                      </Panel>
                    </Collapse>
                  </div>
                  {correctiveStatus && correctiveStatus !== null && correctiveStatus === 'Analysis Completed' ?
                    <div
                      style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                      theme={themeSettings}
                    >
                      <Collapse
                        // activeKey={this.state.openPanels}
                        defaultActiveKey={['1']}
                        style={{ width: '1500px' }}
                        expandIcon={({ isActive }) =>
                          isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                        }
                      // onChange={this.onCollapseChange}
                      >
                        <Panel header="Corrective Actions" key="1">
                          <Form
                            name="FailureReport"
                            ref={h4Ref}
                            autoComplete="off"
                            initialValues={correctiveFormObject}
                            layout="horizontal"
                            labelCol={{ flex: '200px' }}
                            labelAlign="right"
                            // onFinish={onAnalysisFormSubmit}
                            onFinishFailed={onCorrectiveFinishFailed}
                            labelWrap
                            // validateMessages={validateMessages}
                            wrapperCol={{ flex: 1 }}
                          >
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px' }}>
                              <Form.Item name="Id"></Form.Item>

                              <Form.Item
                                label={translation('Change Recommendations')}
                                name="ChangeRecommendations"
                                rules={[
                                  {
                                    required: true,
                                    message: translation("Please Select Change Recommendations!"),
                                  },
                                ]}
                                style={formItemLayout}
                              >
                                <Select
                                  style={{
                                    width: '70%'
                                  }}
                                  placeholder="Select Change Recommendations"
                                >
                                  <Option value={'SECP'}>Software Engineering Change Proposal</Option>
                                  <Option value={'HECP'}>Hardware Engineering Change Proposal</Option>
                                </Select>
                              </Form.Item>

                              <Form.Item
                                label={translation('Corrective Action Type')}
                                name="CorrectiveActionType"
                                rules={[
                                  {
                                    required: true,
                                    message: translation("Please Select Corrective Action Types!"),
                                  },
                                ]}
                                style={formItemLayout}
                              >
                                <Select
                                  style={{
                                    width: '70%'
                                  }}
                                  placeholder="Select Corrective Action Type"
                                >
                                  <Option value={'Design'}>Design</Option>
                                  <Option value={'ShortTerm'}>Short Term</Option>
                                  <Option value={'LongTerm'}>Long Term</Option>

                                </Select>
                              </Form.Item>
                              <Form.Item
                                label={translation('Planned Corrective Actions')}
                                name="PlannedCorrectiveActions"
                                rules={[
                                  {
                                    required: true,
                                    message: translation("Please Input Planned Corrective Actions!"),
                                  },
                                ]}
                                style={formItemLayout}
                              >
                                <Input
                                  placeholder="Input Planned Corrective Actions"
                                  style={{
                                    width: '70%'
                                  }}
                                />
                              </Form.Item>
                              <Form.Item
                                label={translation('Implemented Corrective Actions')}
                                name="ImplementedCorrectiveActions"
                                rules={[
                                  {
                                    required: true,
                                    message: translation("Please Input Implemented Corrective Actions!"),
                                  },
                                ]}
                                style={formItemLayout}
                              >
                                <Input
                                  placeholder="Input Implemented Corrective Actions"
                                  style={{
                                    width: '70%'
                                  }}
                                />
                              </Form.Item>
                              <Form.Item
                                style={formItemLayout}
                                name="CorrectiveActionsAttachments"
                                label={translation('Corrective Actions Attachments')}
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: translation("Corrective Actions Attachments!"),
                              //   },
                              // ]}
                              >
                                <Select
                                  // disabled={formObject.Status === 'Open' ? false : true}

                                  style={{ width: '70%' }}
                                  placeholder={'Add/View Attachments'}
                                  onSelect={correctiveHandleClick}
                                >
                                  <Option key={'View Attachments'} value={'View Attachments'}>
                                    View Attachments
                                  </Option>
                                  <Option key={'Add New Attachments'} value={'Add New Attachments'}>
                                    Add New Attachments
                                  </Option>
                                </Select>
                                <Upload
                                  // accept="text/csv"
                                  multiple={true}
                                  beforeUpload={(file) => {
                                    const isCSV =
                                      file.type === 'image/jpeg' ||
                                      file.name.endsWith('.jpg') ||
                                      file.name.endsWith('.jpeg') ||
                                      file.name.endsWith('.pdf') ||
                                      file.name.endsWith('.png') ||
                                      file.name.endsWith('.ppt') ||
                                      file.name.endsWith('.pptx') ||
                                      file.name.endsWith('.xls') ||
                                      file.name.endsWith('.xlsx') ||
                                      file.name.endsWith('.docx') ||
                                      file.name.endsWith('.doc')
                                      ;
                                    if (!isCSV) {
                                      message.error(`You can not upload ${file.type} files!`);
                                    }
                                    const isLt2M = file.size / 1024 / 1024 < 2;
                                    if (!isLt2M) {
                                      message.error('File must be smaller than 2MB!');
                                    }
                                    return isCSV && isLt2M;
                                  }}
                                  //   beforeUpload={beforeUpload}
                                  // beforeUpload={this.filebeforeUpload}
                                  // ref={this.myRef}
                                  onChange={(info) => correctiveFileUpload(info)}
                                  action={`/api/fracas/reporting/saveFile?SiteId=${siteId}&Type=${'fracas'}&Source=${'CorrectiveActions'}`}
                                  headers={{
                                    Authorization: Authorization
                                  }}
                                  showUploadList={false}
                                >
                                  <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                    <UploadOutlined /> Upload
                                  </Button>
                                </Upload>
                                <Drawer
                                  title="Corrective Actions Uploaded Files"
                                  open={correctiveShowusecasedownloadModal}
                                  width={'50%'}
                                  onOk={() => setCorrectiveShowusecasedownloadModal(false)}
                                  onClose={() => setCorrectiveShowusecasedownloadModal(false)}
                                >
                                  <StyledTable size="small"
                                    columns={UseCaseColumns}
                                    dataSource={
                                      correctiveFormObject &&
                                        correctiveFormObject.CorrectiveActionsAttachments &&
                                        Array.isArray(correctiveFormObject.CorrectiveActionsAttachments) &&
                                        correctiveFormObject.CorrectiveActionsAttachments
                                        ? [...correctiveFormObject.CorrectiveActionsAttachments]
                                        : []
                                    }
                                  />
                                </Drawer>
                              </Form.Item>
                              <Form.Item
                                label={translation('Verification and Validation field remarks')}
                                name="VerificationAndValidationFieldRemarks"
                                //  rules={[
                                //   {
                                //     required: true,
                                //     message: translation("Please Input Verification and Validation field remarks!"),
                                //   },
                                // ]}
                                style={formItemLayout}
                              >
                                <Input
                                  placeholder="Input Verification and Validation field remarks"
                                  style={{
                                    width: '70%'
                                  }}
                                />
                              </Form.Item>

                            </div>
                          </Form>
                        </Panel>
                      </Collapse>
                    </div>
                    : null}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'right',
                      paddingRight: '5%',
                      paddingTop: '2%'
                    }}
                  >
                    {correctiveButton && correctiveButton === true ?
                      <Form.Item>
                        <Button type="primary" style={{ marginRight: 8 }} onClick={onCorrectiveActionClick}>
                          Proceed to Corrective Actions
                        </Button>
                      </Form.Item>
                      : null}
                    <Form.Item>
                      <Button type="primary" style={{ marginRight: 8 }} htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel}>
                        Cancel
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </TabPane>
            </Tabs>
          </TabPane>
        ) : null}
      </Tabs>
      <Modal
        open={questionVisible}
        width={800}
        height={800}
        closable
        title={'Questions'}
        onOk={onQuestionModalsOk}
        onCancel={onQuestionModalCancel}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div
            style={{
              paddingTop: '20px'
              // ,paddingLeft:'200px'
            }}
          >
            <Form
              name="dynamic_form_nest_item"
              autoComplete="off"
              ref={QuestionRef}
              initialValues={{ Questions: Questions }}
              style={{ paddingLeft: '5%' }}
              layout="vertical"
              className="Answers_Form"
            >
              <Form.List name="Questions">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          label="Question"
                          {...restField}
                          name={[name, 'QuestionId']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Question'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Question"
                            // maxTagCount={1}
                            style={{ width: '350px' }}
                          // mode="multiple"
                          // onChange={(value) => onQuestionChange('Question', value)}
                          >
                            {questionsList &&
                              Array.isArray(questionsList) &&
                              questionsList.map((item, index) => {
                                return (
                                  <option key={index} value={item.Id}>
                                    {item.Question}
                                  </option>
                                );
                              })}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          label="Answer"
                          name={[name, 'Answers']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Answer'
                            }
                          ]}
                        >
                          <Input
                            placeholder="Answer"
                            style={{ width: '350px' }}
                          />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        style={{ width: '500px' }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Question
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        onCancel={() => setTreeVisible(false)}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
      >
        <HierarchyModal
          checkedArray={checkedValue || []}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          //   selectedOption={selectedOption}
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    // userProfile: state.LayoutReducer.userProfile,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
    UserDetails: state.LayoutReducer.UserDetails,
  };
};
export default connect(mapStateToProps)(FailureReports);